
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Page } from '@/types/page';
import moment from 'moment';

@Component
export default class PageListTile extends Vue {
  @Prop() page!: Page;

  /* get updatedDate(): string {
    return this.fromNow(this.page.updated_at);
  } */

  fromNow(fromDate: string): string {
    const fromMoment: moment.Moment = moment(fromDate);
    const now: moment.Moment = moment();
    return now.diff(fromMoment, 'days') > 1
      ? fromMoment.calendar()
      : fromMoment.fromNow();
  }
}
